export default __webpack_public_path__ + "static/media/banner2.53ba7125.jpg";